module.exports = __webpack_public_path__ + "img/personel-2.png";